import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, deleteDoc, setDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, uploadString, getDownloadURL, deleteObject } from "firebase/storage";
// import Vue from "vue";
// import Axios from "axios";
// import VueAxios from "vue-axios";
import { v4 as uuidv4 } from "uuid";

// Vue.use(VueAxios, Axios);

const db = getFirestore();

const storageInstance = getStorage()
const storage = ref(storageInstance, "programsVideos/");
const storageImages = ref(storageInstance, "programsImages/");

export default {
    state: {
        programsList: [],
        programsFilters: [],
        loadingStatusVideoProgram: 0,
        loadingStatusPreviewImageProgram: 0
    },
    mutations: {
        SET_PROGRAMS_LIST(state, programsList) {
            state.programsList = programsList
        },
        SET_PROGRAMS_FILTER_LIST(state, programsFilters) {
            state.programsFilters = programsFilters
        },
        SET_VALUE_LOADING_STATUS_VIDEO_PROGRAM(state, value) {
            state.loadingStatusVideoProgram = value
        },
        SET_VALUE_LOADING_STATUS_PREVIEW_IMAGE_PROGRAM(state, value) {
            state.loadingStatusPreviewImageProgram = value
        },
        DELETE_PROGRAM_FROM_LIST(state, program) {
            let index = state.programsList.findIndex(p => p.id === program.id)
            state.programsList.splice(index, 1)
        }
    },
    actions: {
        GetProgramsList({ commit }){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "programsList"))
                    const programsList = []
                    querySnapshot.forEach((doc) =>  {
                        programsList.push(doc.data())
                    })
                    commit('SET_PROGRAMS_LIST', programsList)
                    resolve(programsList)
                } catch(error) {
                    reject(error)
                }
            })
        },
        GetProgram({ }, program){
            return new Promise(async (resolve, reject) => {
                try {
                    let resProgram = await getDoc(doc(db, "programsList", program.id))
                    let gettedProgram = resProgram.data()
                    gettedProgram.endDay = gettedProgram.endDay ? gettedProgram.endDay.toDate() : ''
                    if(gettedProgram.subscription && gettedProgram.subscription != ""){
                        let subscription = await gettedProgram.subscription.get()
                        gettedProgram.subscription = subscription.data()
                    }
                    console.log(JSON.stringify(gettedProgram));
                    resolve(gettedProgram)
                } catch(error) {
                    reject(error)
                }
            })
        },
                UploadVideoProgram({ commit }, program) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storageInstance, `programsVideos/${random}`);
                    let bytes = new Blob([new Uint8Array(program.presentationVideo.blob)]);
                    console.log('storageRef', storageRef.name);
                    let metadata = {
                        contentType: 'video/mp4'
                    }
                    
                    // Upload the bytes
                    await uploadBytes(storageRef, bytes, metadata);
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        UploadImagePreviewProgram({ commit }, program) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storageInstance, `programsImages/${random}`);
                    console.log('storageRef', storageRef.name);
                    
                    // Upload the string
                    await uploadString(storageRef, program.selectedImagePreview.img, "data_url");
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        CreateProgram({}, program) {
            return new Promise(async(resolve, reject) => {
                if (program.presentationVideo && program.presentationVideo.video) {
                    delete program.presentationVideo.video
                }
                if (program.selectedImagePreview && program.selectedImagePreview.img) {
                    delete program.selectedImagePreview.img
                }
                                 if(program.subscription && program.subscription != ""){
                     program.subscription = doc(db, "subscriptionsList", program.subscription.id)
                 }
                 const newDocRef = doc(collection(db, "programsList"));
                 program.id = newDocRef.id;
                 program.createdAt = new Date()
                 program.updatedAt = new Date()
                 await setDoc(newDocRef, program)
                    .then(async(res) => {
                        console.log('newDocRef.id', newDocRef.id);
                        resolve(newDocRef.id);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            })
        },
        UpdateProgram({}, program) {
            return new Promise(async(resolve, reject) => {
                if (program.presentationVideo && program.presentationVideo.video) {
                    delete program.presentationVideo.video
                }
                if (program.selectedImagePreview && program.selectedImagePreview.img) {
                    delete program.selectedImagePreview.img
                }
                                 if(program.subscription && program.subscription != ""){
                     program.subscription = doc(db, "subscriptionsList", program.subscription.id)
                 }
                if(program.createdAt) {
                    delete program.createdAt
                }
                program.updatedAt = new Date()
                await updateDoc(doc(db, "programsList", program.id), program)
                    .then((res) => {
                        resolve(program.id);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        DeleteProgram({ commit }, program) {
            return new Promise(async(resolve, reject) => {
                if (program.presentationVideo && program.presentationVideo.ref) {
                    let storageRef = ref(storageInstance, program.presentationVideo.ref);
                    try {
                        await deleteObject(storageRef)
                    } catch (error) {
                        reject(error)
                    }
                }
                if (program.selectedImagePreview && program.selectedImagePreview.ref) {
                    let storageRefImage = ref(storageInstance, program.selectedImagePreview.ref);
                    try {
                        await deleteObject(storageRefImage)
                    } catch (error) {
                        reject(error)
                    }
                }
                try {
                    await deleteDoc(doc(db, "programsList", program.id))
                    commit('DELETE_PROGRAM_FROM_LIST', program)
                    resolve(program.id)
                } catch (error) {
                    reject(error)
                }
            })
        },
        DisableProgram({}, program){
            return new Promise(async(resolve, reject) => {
                try {
                    await updateDoc(doc(db, "programsList", program.id), {
                      enabled: !program.enabled
                    })
                    resolve(program.id);
                } catch (error) {
                    reject(error);
                }
            });

        },
        /**
         * Las definiciones de filtros de programas: qué objetivos y qué zonas
         * se pueden elegir. Solo lectura desde aquí; los valores se crean con
         * `docs/data/crearProgramsFilters.js` en la app móvil.
         *
         * Es colección aparte de `preSetsFilters` a propósito, pero los
         * objetivos DEBEN escribirse igual en las dos: el chat los compara como
         * texto exacto contra el perfil del usuario, así que "Burn Fat" filtra
         * y "Burn fat" no encuentra nada, sin error que lo delate.
         */
        // Sin envolver en `new Promise`, a diferencia del resto del archivo: una
        // acción async ya devuelve una promesa, y el envoltorio dispara
        // no-async-promise-executor, que ESLint marca 8 veces más aquí.
        async GetFiltersListPrograms({ commit }) {
            const querySnapshot = await getDocs(collection(db, "programsFilters"))
            const programsFilters = []
            querySnapshot.forEach((doc) => {
                let filterProgram = doc.data()
                filterProgram.type = doc.id
                programsFilters.push(filterProgram)
            })
            commit('SET_PROGRAMS_FILTER_LIST', programsFilters)
            return programsFilters
        }

    },
    getters: {
        getProgramsList(state) {
            return state.programsList
        },
        getLoadingStatusVideoProgram(state) {
            return state.loadingStatusVideoProgram
        },
        getLoadingStatusPreviewImageProgram(state) {
            return state.loadingStatusPreviewImageProgram
        },
        getProgramsFilters(state) {
            return state.programsFilters
        },
    }
}